<template>
	<page style="background: #fff;">
		<c-form ref="form">
			<!--送修人不作选择：谁操作送修谁就是送修人，且只能是商品的当前接驳人-->
			<c-form-item label="维修单位" required>
				<c-input name="repair_unit" placeholder="请输入"></c-input>
			</c-form-item>
			<c-form-item label="送修时间" required>
				<c-datetime name="delivery_date"></c-datetime>
			</c-form-item>
			<c-form-item label="备注">
				<c-input name="remark" type="textarea"></c-input>
			</c-form-item>
			<c-form-item ref="items" label="送修商品" name="items" required>
				<template #handle>
					<span style="font-size: .26rem; color: #aaa;"><span style="color: var(--color-main)">{{productList.length}}</span>条记录</span>
				</template>
				<insert-data scan-name="扫码送修" @scan="scanHandle"></insert-data>
				<detail-card v-for="(item, i) in productList" :key="i" :index="i + 1" remove-button @remove="productList.splice(i, 1)">
					<template #title>
						<span>{{[item.brand_name, item.model_name, item.color_name, item.memory_name].filter(item => item).join(' ')}}</span>
					</template>

					<template #default>
						<c-field label="背贴码">{{item.produce_unique_code}}</c-field>
						<!--门店版没有接驳环节，取不到接驳人，这一行恒为空，不摆出来-->
						<c-field v-if="hasHandover" label="当前接驳人">{{item.handler_user_name || '-'}}</c-field>
					</template>
				</detail-card>
			</c-form-item>
		</c-form>

		<template #button>
			<c-button color="main" hollow size="form" @click="mp.navigateBack()">取消</c-button>
			<c-button class="foot-button" size="form" color="main" @click="submitHandle">确认提交</c-button>
		</template>
	</page>
</template>

<script>
	import {mapGetters} from 'vuex'

	export default {
		props: {
			/**背贴码，由商品列表（门店版无维修工作台）带入，用于预填送修商品、免重复扫码*/
			code: [String, Number]
		},

		data() {
			return {
				productList: []
			}
		},

		computed: {
			/**是否接驳作业（门店版为false）：能力开关由服务端登录信息下发，端内不判版本编码*/
			...mapGetters(['hasHandover'])
		},

		mounted() {
			if (this.code) {
				this.scanHandle(this.code);
			}
		},

		methods: {
			scanHandle(code) {
				if (this.productList.some(item => item.produce_unique_code == code)) {
					this.$message({
						message: '该背贴码已存在'
					});
					return;
				}
				this.request({
					url: '/repair/product/queryByCode',
					data: {
						produce_unique_code: code
					},
					success: data => {
						this.productList.push(data);
					}
				});
			},

			submitHandle() {
				this.$refs.form.submit({
					url: '/repair/delivery/batchAdd',
					rule: {
						repair_unit: '请填写维修单位',
						delivery_date: '请选择送修时间',
						items: [{
							type: 'function',
							message: '请扫描送修商品',
							fun: () => {
								return this.productList.length;
							}
						}]
					},
					dataFormatter: data => {
						return Object.assign(data, {
							products: JSON.stringify(this.productList.map(item => {
								return {
									produce_unique_code_id: item.produce_unique_code_id,
									/**回传背贴码，供后端拦截提示定位到具体商品*/
									produce_unique_code: item.produce_unique_code || ''
								}
							}))
						})
					},
					success: () => {
						this.$message({
							message: '提交成功',
							mask: true
						});
						this.mp.navigateBack(true);
					}
				})
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>